import createGlobe from 'cobe'
import { useEffect, useRef } from 'react'

const markers: { location: [number, number]; size: number }[] = [
	{ location: [48.8566, 2.3522], size: 0.05 },
	{ location: [51.5074, -0.1278], size: 0.045 },
	{ location: [40.7128, -74.006], size: 0.045 },
	{ location: [37.7749, -122.4194], size: 0.045 },
	{ location: [35.6762, 139.6503], size: 0.045 },
	{ location: [-33.8688, 151.2093], size: 0.045 },
	{ location: [-23.5505, -46.6333], size: 0.045 },
	{ location: [52.52, 13.405], size: 0.045 },
]

export function FooterGlobe() {
	const canvasRef = useRef<HTMLCanvasElement>(null)

	useEffect(() => {
		const canvas = canvasRef.current
		if (!canvas) return
		const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

		let size = canvas.offsetWidth || 420
		let phi = 4.2
		let frame = 0

		const globe = createGlobe(canvas, {
			devicePixelRatio: Math.min(window.devicePixelRatio || 1, 2),
			width: size,
			height: size,
			phi: 0,
			theta: 0.25,
			dark: 1,
			diffuse: 1,
			mapSamples: 16000,
			mapBrightness: 6,
			baseColor: [0.78, 0.73, 1],
			markerColor: [1, 0.87, 0.35],
			glowColor: [0.4, 0.36, 0.58],
			markers,
		})

		const render = () => {
			if (!reducedMotion) phi += 0.004
			const next = canvas.offsetWidth || size
			const state: Parameters<typeof globe.update>[0] = { phi }
			if (next !== size) {
				size = next
				state.width = size
				state.height = size
			}
			globe.update(state)
			frame = requestAnimationFrame(render)
		}

		const observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				if (!frame) frame = requestAnimationFrame(render)
			} else if (frame) {
				cancelAnimationFrame(frame)
				frame = 0
			}
		})
		observer.observe(canvas)

		return () => {
			observer.disconnect()
			if (frame) cancelAnimationFrame(frame)
			globe.destroy()
		}
	}, [])

	return <canvas ref={canvasRef} className="fb-footer-globe-canvas" aria-hidden="true" />
}
